import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const data = [
  { name: 'Mon', sent: 120, delivered: 118, read: 100 },
  { name: 'Tue', sent: 150, delivered: 145, read: 130 },
  { name: 'Wed', sent: 180, delivered: 175, read: 160 },
  { name: 'Thu', sent: 140, delivered: 138, read: 120 },
  { name: 'Fri', sent: 200, delivered: 195, read: 180 },
];

const WhatsAppAnalytics = () => {
  return (
    <div className="space-y-6" data-testid="whatsapp-analytics-page">
      <h2 className="text-xl font-bold text-gray-800">WhatsApp Campaign Analytics</h2>
      
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <h3 className="font-bold text-gray-700 mb-6">Message Delivery Status</h3>
        <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="sent" fill="#94a3b8" name="Sent" />
                    <Bar dataKey="delivered" fill="#3b82f6" name="Delivered" />
                    <Bar dataKey="read" fill="#22c55e" name="Read" />
                </BarChart>
            </ResponsiveContainer>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <h4 className="text-sm font-medium text-gray-500">Total Messages Sent</h4>
          <p className="text-3xl font-bold text-gray-900 mt-2">790</p>
          <p className="text-sm text-green-600 mt-1">+12% from last week</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <h4 className="text-sm font-medium text-gray-500">Delivery Rate</h4>
          <p className="text-3xl font-bold text-gray-900 mt-2">97.5%</p>
          <p className="text-sm text-green-600 mt-1">Above average</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <h4 className="text-sm font-medium text-gray-500">Read Rate</h4>
          <p className="text-3xl font-bold text-gray-900 mt-2">87.3%</p>
          <p className="text-sm text-green-600 mt-1">+5% from last week</p>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppAnalytics;
